import {
  Paper,
  Box,
  Typography,
} from "@mui/material";

const ViewSheet = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 0,
        borderRadius: 2,
        border: "1px solid #e2e8f0",
        overflow: "hidden",
        backgroundColor: "#fff",
        display: "block",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          // borderBottom: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontWeight: 600, color: "#2d3748" }}>
          Our Property Portfolio
        </Typography>
      </Box>
      <Box sx={{ height: 974, overflow: "hidden", position: "relative" }}>
        <iframe
          title="Our Portfolio"
          // src="https://docs.google.com/spreadsheets/d/1rZ_VFTlXk_8CzqYn3O--n5c6WqKbMALU/edit?gid=1179682924#gid=1179682924"
          src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQ2-P38LQVmbI9osus1w-MRD3qYc16yECzY0vE88tW_r9HAaQm9j9Ry8uL5hxwYEQ/pubhtml?gid=1179682924&single=true"
          width="100%"
          height="1000"
          style={{
            border: "none",
          }}
        />
      </Box>
    </Paper>
  );
};

export default ViewSheet;